/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDeviceServicesStopMutationResponse, StreamerBoxStreamerBoxDeviceServicesStopPathParams } from "../models/StreamerBoxStreamerBoxDeviceServicesStop";

export function getStreamerBoxStreamerBoxDeviceServicesStopUrl(uuidOrId: StreamerBoxStreamerBoxDeviceServicesStopPathParams["uuidOrId"], imageId: StreamerBoxStreamerBoxDeviceServicesStopPathParams["imageId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/services/${imageId}/stop` as const }
  return res
}

/**
 * @description Stops a service on the device for the given image id.
 * @summary Stop service
 * {@link /streamer-box/devices/:uuidOrId/services/:imageId/stop}
 */
export async function streamerBoxStreamerBoxDeviceServicesStop(uuidOrId: StreamerBoxStreamerBoxDeviceServicesStopPathParams["uuidOrId"], imageId: StreamerBoxStreamerBoxDeviceServicesStopPathParams["imageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDeviceServicesStopMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStreamerBoxStreamerBoxDeviceServicesStopUrl(uuidOrId, imageId).url.toString(), ... requestConfig })
  return res.data
}